'use strict';

/**
 * A method that detects support for "passive" as an option for addEventListener / removeEventListner,
 * and returns the value that should be used for the browser.
 * 
 * A "passive" listener is one that will not call preventDefault().
 * 
 * For details on "passive" see: https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * The feature detection is based on: https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
 * 
 * Example use:
 * scrollAreaElement.addEventListener.('scroll', function(event) {...}, EventListenerOption.get());
 * 
 * By default the returned option will be set to "capture" false and "passive" true.
 */


var EventListenerOption = {};
var _isCapturePassiveOpts = {
		capture: true,
		passive: true
	},
	_isNotCapturePassiveOpts  = {
		capture: false,
		passive: true
	},
	_isCaptureNotPassiveOpts = {
		capture: true,
		passive: false
	},
	_isNotCaptureNotPassiveOpts  = {
		capture: false,
		passive: false
	};

/**
 * @public
 * @param {boolean} [isCapture=false]
 * @param {boolean} [isPassive=true]
 */
EventListenerOption.get = function(isCapture, isPassive) {
	if (isPassiveSupported()) {
		return isCapture === true ?
				isPassive !== false ? _isCapturePassiveOpts : _isCaptureNotPassiveOpts
					: isPassive !== false ? _isNotCapturePassiveOpts : _isNotCaptureNotPassiveOpts;
	} else {
		// No support return capture value
		return isCapture === true;
	}
}

/**
 * @private
 */
var _isPassiveSupported;
function isPassiveSupported() {
	if (_isPassiveSupported === undefined) {
		// Test via a getter in the options object to see if the passive
		// property is accessed
		var supportsPassive = false;
		try {
			var opts = Object.defineProperty({}, 'passive', {
				get : function() {
					supportsPassive = true;
				}
			});
			window.addEventListener('test', null, opts);
		} catch (e) {}
		_isPassiveSupported = supportsPassive;
	}
	return _isPassiveSupported;
}

module.exports = EventListenerOption;



